import React, { useState, useEffect } from "react";
import "./styles.css";

export default function ImageUploader({
  label = "Sélectionner une image",
  value,            // le File (ou null)
  onChange          // fonction (file) => void
}) {
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    if (!value) {
      setPreview(null);
      return;
    }
    const reader = new FileReader();
    reader.onloadend = () => setPreview(reader.result);
    reader.readAsDataURL(value);
  }, [value]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      onChange(file);
    }
  };

  const handleRemove = () => {
    onChange(null);
  };

  return (
    <div className="input-file">
      <label>{label}</label>

      {/* Si pas d'image, on affiche le bouton */}
      {!preview && (
        <input
          type="file"
          accept="image/*"
          onChange={handleFileChange}
        />
      )}

      {/* Si image, on affiche l'aperçu avec la croix */}
      {preview && (
        <div className="image-preview">
          <button
            type="button"
            className="remove-button"
            onClick={handleRemove}
          >
            &times;
          </button>
          <img
            src={preview}
            alt="Aperçu"
            style={{ maxWidth: "200px", maxHeight: "200px" }}
          />
        </div>
      )}
    </div>
  );
}
